import IntegralGoodsOffShelves from './integral_goods_off_shelves.vue';

export default IntegralGoodsOffShelves;
